export default __webpack_public_path__ + "static/4-0_HSR_Icon-4a968e009223ade90c661f2df77e5492.png";